import styled from 'styled-components';
import { Box, Button } from '@rsos/base-components';

export const RequestADRBanner = styled(Box).attrs({
  width: '100%',
  align: 'center',
  justify: 'space-between',
  borderRadius: '5px',
  gridColumnGap: '8px',
  px: '16px',
  py: '7px',
})``;

export const RequestADRButton = styled(Button).attrs({
  'data-name': 'request-adr-button',
  btnType: 'secondary',
  size: 'small',
  px: 20,
})``;

export const CloseButton = styled.button`
  background: transparent;
  padding: 0;
  margin: 0;
  outline: 0;
  border: 0;
  line-height: 0px;
  display: inline-block;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.secondaryText};
`;
